// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseUrl: 'https://api.uplifesolution.vn',
  pathJsonConfig: 'ECM/system/fe',
  firebaseConfig: {
    apiKey: "AIzaSyDLNoIRcizSIMSJCxc4uvHSkNr3ikpEQj4",
    authDomain: "uplife-notification-fbase.firebaseapp.com",
    projectId: "uplife-notification-fbase",
    storageBucket: "uplife-notification-fbase.firebasestorage.app",
    messagingSenderId: "104298671348",
    appId: "1:104298671348:web:0200eac006a321066702a1",
    measurementId: "G-JK41XXYER4"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
